import { render, staticRenderFns } from "./process .vue?vue&type=template&id=5e96fbc2&scoped=true&"
import script from "./process .vue?vue&type=script&lang=js&"
export * from "./process .vue?vue&type=script&lang=js&"
import style0 from "./process .vue?vue&type=style&index=0&id=5e96fbc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96fbc2",
  null
  
)

export default component.exports